export default __webpack_public_path__ + "static/media/home_01_active.71aca3b2.png";